import { Component, input, output } from '@angular/core';

/**
 * Houdt (wanneer enabled) alle kliks tegen dmv een transparante div met hoge z-index.
 * "wheel" events (scrollen) worden wel doorgelaten.
 */
@Component({
	selector: 'app-click-blocking-overlay',
	templateUrl: './click-blocking-overlay.component.html',
	styleUrls: ['./click-blocking-overlay.component.scss'],
})
export class ClickBlockingOverlayComponent {
	readonly enabled = input.required<boolean>();

	clicked = output<void>();

	scrollUnderOverlay($event: Event) {
		const wheelEvent = $event as WheelEvent;
		wheelEvent.preventDefault();

		const { clientX, clientY, deltaX, deltaY } = wheelEvent;

		const elementUnder = findElementUnder(wheelEvent.target as HTMLElement, clientX, clientY);
		if (!elementUnder) {
			// If nothing is found (unlikely), scroll the window
			scrollTarget(window, deltaX, deltaY);
			return;
		}

		const scrollableElement = findNearestScrollableAncestor(elementUnder, deltaX, deltaY);
		if (scrollableElement) {
			scrollTarget(scrollableElement, deltaX, deltaY);
		} else {
			scrollTarget(window, deltaX, deltaY);
		}
	}
}

function findElementUnder(overlay: HTMLElement, clientX: number, clientY: number) {
	// Temporarily disable pointer-events on the overlay, so elementFromPoint finds the element underneath
	overlay.style.pointerEvents = 'none';
	const elementUnder = document.elementFromPoint(clientX, clientY);
	overlay.style.pointerEvents = 'auto';
	return elementUnder;
}

function findNearestScrollableAncestor(elementUnder: Element, deltaX: number, deltaY: number) {
	let target: Element | null = elementUnder;

	while (target && target !== document.body) {
		const style = window.getComputedStyle(target);

		const overflowX = style.getPropertyValue('overflow-x');
		const isScrollableX = overflowX === 'auto' || overflowX === 'scroll';
		const hasOverflowX = target.scrollWidth > target.clientWidth;

		const overflowY = style.getPropertyValue('overflow-y');
		const isScrollableY = overflowY === 'auto' || overflowY === 'scroll';
		const hasOverflowY = target.scrollHeight > target.clientHeight;

		if ((isScrollableX && hasOverflowX && deltaX !== 0) || (isScrollableY && hasOverflowY && deltaY !== 0)) {
			return target;
		}

		target = target.parentElement;
	}
	return target;
}

function scrollTarget(target: Element | Window, deltaX: number, deltaY: number) {
	target.scrollBy({
		top: deltaY,
		left: deltaX,
		behavior: 'auto',
	});
}
